import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {
  buildDirectHoverSelector,
  buildHoverParentClassName,
} from '../../../../../libs/shared/core/src/helpers/browser/hoverHelpers';

/*
 * Props.
 */

interface ComposerSectionProps {
  hasHover?: boolean;
  hasFocus?: boolean;
  hoverOutline?: boolean;
}

/*
 * Style.
 */

interface SectionStyleProps {
  $hoverOutline?: boolean;
  $hasFocus?: boolean;
}
const StyledSectionDiv = styled.div<SectionStyleProps>`
  flex-shrink: 0;

  display: grid;
  grid-template-areas:
    'left-actions .       right-actions'
    'content      content right-actions';
  grid-template-columns: max-content 1fr max-content;

  & + & {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 8px;
  }

  position: relative;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    height: 100%;
    left: 8px;
    width: calc(100% - 8px * 2);
    ${(p) =>
      p.$hoverOutline
        ? `border: 2px solid ${p.$hasFocus ? p.theme.palette.blue.shade40 : p.theme.alphas.gray20}`
        : `background: ${p.theme.alphas.gray10}`};
    border-radius: 4px;
    pointer-events: none;
    opacity: 0;
  }

  ${buildDirectHoverSelector('::before')} {
    opacity: 1;
  }
`;

/*
 * Component.
 */

export const ComposerSection: FC<PropsWithChildren<ComposerSectionProps>> = (props) => (
  <StyledSectionDiv
    $hoverOutline={props.hoverOutline}
    $hasFocus={props.hasFocus}
    className={buildHoverParentClassName(props.hasHover)}
  >
    {props.children}
  </StyledSectionDiv>
);
